import { createScopedTranslationKeys } from '@dreryk/react-common';

export const systemActivityTranslations = {
   pl: {
      systemActivity: {
         accept: 'Zaakceptuj',
         acceptSuccess: 'Dostęp do danych dla: {{practitionerName}} został przyznany.',
         accessExpirationDate: 'Wygaśnięcie dostępu',
         accessGrantedDate: 'Udzielenie dostępu',
         author: 'Autor danych',
         close: 'Zamknij',
         confidentialResourcesListTitle: 'Lista wizyt poufnych zawartych w wygenerowanej dokumentacji medycznej',
         confidentialVisitAccusative: 'wizyta poufna',
         confidentialVisitGenitive: 'wizyty poufne',
         confidentialVisitPlural: 'wizyt poufnych',
         considerConfidentialDataRequest: 'Rozpatrz prośbę o dostęp do danych poufnych',
         dataAuthor: 'Autor danych',
         dataAuthorAccusative: 'autor',
         dataAuthorPlural: 'autorów',
         dataAuthorsCount: '{{count}} {{suffix}}',
         dataCategory: 'Kategoria danych',
         dataSubject: 'Dane, których dotyczy wniosek',
         dateAndTime: 'Data i czas',
         decisionDateRejected: 'Odmowa: {{decisionDate}}',
         documentationGenerationJustification: 'Wygenerowanie dokumentacji medycznej',
         grantAccess: 'Udziel dostępu',
         grantingPractitioner: 'Zatwierdzający',
         medicalDataAccess: 'Dostęp do danych medycznych',
         noActivity: 'Brak aktywności związanej z danymi poufnymi',
         ordinalNumber: 'L.p.',
         patient: 'Pacjent',
         reason: 'Uzasadnienie',
         reasonPlaceholder: 'Wpisz uzasadnienie decyzji...',
         rejectAccess: 'Nie udzielaj dostępu',
         rejectSuccess: 'Dostęp do danych dla: {{practitionerName}} został odrzucony.',
         requestSentDate: 'Wysłanie prośby',
         requestSentDateLabel: 'Data wysłania prośby',
         requestingPractitioner: 'Wnioskujący',
         resourceTypeMap: {
            MEDICAL_DOCUMENT: 'Dokumentacja medyczna',
            MEDICAL_INFORMATION: 'Dane medyczne',
            PATIENT_MEDICAL_DOCUMENTATION: 'Dokumentacja medyczna',
            PATIENT_MEDICAL_DOCUMENTATION_GENERATION: 'Dokumentacja medyczna',
            VISIT: 'Wizyta lekarska',
            VISIT_SUMMARY: 'Karta wizyty',
         },
         review: 'Rozpatrz',
         revokeAccess: 'Wycofaj dostęp',
         revokeAccessConfirmation:
            'Czy na pewno chcesz wycofać dostęp przyznany dla {{practitionerName}} do danych: {{dataCategory}}?',
         revokeAccessTitle: 'Wycofaj dostęp do danych poufnych',
         revokeSuccess: 'Dostęp do danych dla: {{practitionerName}} został wycofany.',
         system: 'System',
         systemActivity: 'Aktywność systemowa',
         thereWillBeVisitAccessHistory: 'W tym miejscu pojawi się historia dostępu i wniosków użytkowników.',
      },
   },
};

export const systemActivityTranslationKeys = createScopedTranslationKeys(
   systemActivityTranslations.pl,
   'systemActivity'
);
